import styled from 'styled-components/macro'

export const SuccessMessageWrapper = styled.div`
  display: flex;
  justify-content: center;
`
